import React from 'react'
import loaders from '../assets/img/loaders.gif'

const Loader = () => {
    return (
        <div>
            <img src={loaders} alt='loader' />
        </div>
    )
}

export default Loader
